import { render, staticRenderFns } from "./LoadingVeridas.vue?vue&type=template&id=8d03bfa4&scoped=true"
import script from "./LoadingVeridas.vue?vue&type=script&lang=js"
export * from "./LoadingVeridas.vue?vue&type=script&lang=js"
import style0 from "./LoadingVeridas.vue?vue&type=style&index=0&id=8d03bfa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d03bfa4",
  null
  
)

export default component.exports